import styled from 'styled-components';
import { Trans } from '@lingui/react/macro';

interface Props {
  className?: string;
}

function MaintenancePage({ className }: Props) {
  return (
    <main className={className}>
      <section>
        <h1>
          <Trans>Идут технические работы</Trans>
        </h1>
        <p>
          <Trans>Пожалуйста, попробуйте выполнить операцию позже.</Trans>
        </p>
      </section>
    </main>
  );
}

export const MaintenancePageView = styled(MaintenancePage)`
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  display: grid;
  place-items: center;
  padding: 24px;
  background: #f3f5f7;
  text-align: center;

  section {
    max-width: 560px;
    padding: 40px;
    border-radius: 8px;
    background: white;
    box-shadow: 0 8px 32px rgba(34, 34, 34, 0.08);
  }

  h1 {
    margin-bottom: 16px;
  }

  p {
    margin: 0;
    font-size: 18px;
  }
`;
